<template>
	<div class="header-fixed header-mobile-fixed subheader-fixed aside-enabled aside-fixed modal-open" :style="progressLoader ? 'pointer-events: none;opacity:0.7' : 'pointer-events: auto'">
	  <sidebar></sidebar>
		<div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
			<topbar></topbar>
			<div id="kt_content" class="content d-flex flex-column flex-column-fluid">
				 <notifications    width="400" group="notify" position="top right"/>
				 <loader v-if="progressLoader"></loader>
				<router-view/>
			</div>
		</div>
	</div>
</template>
<script>
//import quickPanel from '@/js/ordercircle/brands/layouts/shop/shop-quick-panel';
import sidebar from './layouts/admin-sidebar.vue';
import topbar from './layouts/admin-topbar.vue';
//import Footer from '@/js/ordercircle/brands/layouts/admin-footer';
import Loader from "../brands/layouts/Loader.vue";
export default {
	name: 'AdminLayout',
	components: {
		sidebar,
		topbar,
        Loader
	},
    computed:{
        progressLoader(){
			  return this.$store.state.loader
		}
    },
};
</script>
<style scoped>

@media (min-width: 992px) {
    .header-fixed .wrapper {
      padding-top: 150px; }
    .header-fixed.subheader-fixed.subheader-enabled .wrapper {
      padding-top: 119px; 
    }
    .aside-fixed .wrapper {
      padding-left: 150px; }
    .aside-enabled.subheader-fixed .subheader {
        left: 150px !important;
    }  
   
    .container,
    .container-fluid,
    .container-sm,
    .container-md,
    .container-lg,.container-xl,.container-xxl {
      padding: 0 25px; } 
}

</style>
